import { Inter, Manrope } from 'next/font/google';

// Funnel (GYTR / mini-league readiness / landing) typography. Variable fonts,
// so no weight list needed. .funnel-fonts (styles/globals.css) points the semantic
// --font-heading / --font-body tokens at these.
//
// Declared here rather than in _app so that only the routes rendering a funnel
// preload them: fonts set up in _app are preloaded on every page, where they
// compete with each page's LCP image for bandwidth.
const inter = Inter({
  subsets: ['latin'],
  variable: '--font-inter'
});

const manrope = Manrope({
  subsets: ['latin'],
  variable: '--font-manrope'
});

/** Apply together with .funnel-fonts, which reads these variables. */
export const FUNNEL_FONT_VARIABLES = `${inter.variable} ${manrope.variable}`;
